import React from 'react'
import { Line } from 'rc-progress'
import LinesEllipsis from 'react-lines-ellipsis'
import { CURRENT_METRIC_UPDATED } from '../query/metric'

class ActivityComponent extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      activeVehicles: this.get_current_metrics(props.metrics)
    }
  }

  get_current_metrics(metrics) {
    const currentMetrics = metrics.filter((metric) => {
      const metricDate = new Date(metric.occurred_at)
      const today = new Date()
      return metricDate.getDate() === today.getDate() &&
        metricDate.getMonth() === today.getMonth() &&
        metricDate.getFullYear() === today.getFullYear()
    })
    return currentMetrics.length
  }

  componentWillReceiveProps (nextProps) {
    // Update state when latestMetrics prop changes (from polling)
    if (nextProps.metrics !== this.props.metrics) {
      this.setState({
        activeVehicles: this.get_current_metrics(nextProps.metrics)
      })
    }
  }

  render () {
    const allTrbIds = this.props.sensorIds
    const sumVehicle = allTrbIds.length
    const activeVehicles = this.state.activeVehicles
    const activePercent = sumVehicle === 0 ? 0 : Math.round((activeVehicles / sumVehicle) * 100)
    return (
      <div>
        <div style={styles.paper}>
          <LinesEllipsis
            style={styles.title}
            text='ACTIVITE'
            maxLine='1'
            ellipsis='...'
            trimRight
            basedOn='letters'
          />
          <div style={styles.activeContent}>
            <span style={styles.activeNumber}>{activeVehicles}/{sumVehicle}</span>
            <p style={styles.vehicleNumber}>véhicules ont eu une activité <br />aujourd'hui</p>
          </div>
          <div style={styles.lineContent}>
            <Line style={styles.line} percent={activePercent} strokeWidth='1' trailWidth='1' strokeColor='#7ED321' trailColor='#FFA500' />
          </div>
        </div>
      </div>
    )
  }
}

const styles = {
  paper: {
    textAlign: 'left',
    backgroundColor: '#374147',
    height: '380px',
    borderRadius: '16px',
    paddingTop: '12px'
  },
  title: {
    marginLeft: '24px',
    marginTop: '6px',
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#FFFFFF'
  },
  activeContent: {
    textAlign: 'center',
    width: '100%',
    height: '40px',
    marginTop: '96px'
  },
  activeNumber: {
    fontSize: '30px',
    color: '#7ED321',
    fontWeight: 'bold'
  },
  lineContent: {
    marginTop: '142px',
    paddingTop: '4px',
    textAlign: 'center',
    width: '100%',
    height: '28px'
  },
  vehicleNumber: {
    fontSize: '15px',
    color: '#FFFFFF',
    fontWeight: 'bold'
  },
  line: {
    marginLeft: '24px',
    marginRight: '24px'
  }
}

export default ActivityComponent
